import Icon from '@material-ui/icons/History';

import List from "./ExamhistoryList";
import Show from "./ExamhistoryShow";

export default {
  icon: Icon,
  list: List,
  show: Show
};